import React from "react";
import Slider from "react-slick";
import "../../assets/styles/slick.css"
import "../../assets/styles/slick-theme.css"
import "./JSlider.scss"

export default function JSlider({showArrows,numberSlidesToShow,singleItem,items}) {

  var settings = {
    dots: showArrows ? false : true,
    dotsClass: "button__bar",
    //className: "jpagination2",
    speed: 500,
    arrows:showArrows,
    slidesToShow: numberSlidesToShow,
    slidesToScroll: 1,
    autoplay: showArrows ? false : true,
    rtl: false,
    loop: true,
    infinite: showArrows ? false : true,
    adaptiveHeight: true,
    //centerMode: true,
    //fade: true,
    //slide: 'div',
    //cssEase: 'linear'

    responsive: [
      {
          breakpoint: 576, //Mobile
          settings: {
              slidesToShow: showArrows ? 1 : numberSlidesToShow ,
          }
      },
      {
          breakpoint: 920, //Tablet
          settings: {
              slidesToShow: showArrows ? 1 : numberSlidesToShow ,
          }
      },
      {
        breakpoint: 1500, //PC2
        settings: {
            slidesToShow: showArrows ? 2 : numberSlidesToShow ,
        }
    },
    {
      breakpoint: 1700, //PC2
      settings: {
          slidesToShow: showArrows ? 3 : numberSlidesToShow ,
      }
  }
  ]

  };

  return (
    <div className={`${showArrows ? "mainSlide" : "mainSlide2"}`}>
      {/* <div className="mainSlideChild"> */}
        <Slider {...settings} >
            {singleItem!=null ? singleItem : null}
            {items.map(item => (
              <div className="slides">
                  {item}
              </div>
          ))}
          
        </Slider>
      </div>
    // </div>
  );
}